<div class="pt-4 px-4">
  <h3>Modules
    <button class="btn btn-primary float-end " type="submit" data-bs-toggle="modal" data-bs-target="#importConfigModal" >{{"import" | translate}}</button>
    <button class="btn btn-primary float-end me-3" type="submit" (click)="exportModules()">{{"export" | translate}}</button>
  </h3>

  <div class="d-flex flex-sm-wrap pt-2 w-100">
    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12" *ngFor="let module of modules; let i = index">
      <div class="tab">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active text-primary font-weight-bold" href="#icon-tab-1_{{ i }}" data-bs-toggle="tab"
              role="tab">
              {{module.name}}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#icon-tab-2_{{ i }}" data-bs-toggle="tab" role="tab">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-settings align-middle">
                <circle cx="12" cy="12" r="3"></circle>
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                </path>
              </svg>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#icon-tab-3_{{ i }}" data-bs-toggle="tab" role="tab">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-message-square align-middle">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </a>
          </li>
          <li class="nav-item" *ngIf="module.name ==='AMManager'">
            <a class="nav-link" href="#icon-tab-analyzer_{{ i }}" data-bs-toggle="tab" role="tab">
              <i class="fas fa-pager fa-lg"></i>
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square align-middle"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> -->
            </a>
          </li>
          <li class="nav-item" *ngIf="module.name ==='AstCalendar'">
            <a class="nav-link" href="#icon-tab-clock{{ i }}" data-bs-toggle="tab" role="tab">
              <i class="far fa-clock"></i>
            </a>
          </li>
          <li class="nav-item" *ngIf="module.elements && module.elements[0]">
            <a class="nav-link" href="#icon-tab-4_{{ i }}" data-bs-toggle="tab" role="tab"
              *ngIf="module.elements[0].name.startsWith('mennekes')">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="4 4 16 16"
                class="feather feather-message-square align-middle">
                <path
                  d="M7.5 11C7.5 11.28 7.28 11.5 7 11.5S6.5 11.28 6.5 11 6.72 10.5 7 10.5 7.5 10.72 7.5 11M9.5 14.5C9.22 14.5 9 14.72 9 15S9.22 15.5 9.5 15.5 10 15.28 10 15 9.78 14.5 9.5 14.5M9.5 8C9.78 8 10 7.78 10 7.5S9.78 7 9.5 7 9 7.22 9 7.5 9.22 8 9.5 8M14.5 8C14.78 8 15 7.78 15 7.5S14.78 7 14.5 7 14 7.22 14 7.5 14.22 8 14.5 8M12 10.5C11.72 10.5 11.5 10.72 11.5 11S11.72 11.5 12 11.5 12.5 11.28 12.5 11 12.28 10.5 12 10.5M20 11C20 15.42 16.42 19 12 19S4 15.42 4 11C4 8.61 5.06 6.47 6.72 5H17.28C18.94 6.47 20 8.61 20 11M13 7.5C13 8.33 13.67 9 14.5 9S16 8.33 16 7.5 15.33 6 14.5 6 13 6.67 13 7.5M8 7.5C8 8.33 8.67 9 9.5 9S11 8.33 11 7.5 10.33 6 9.5 6 8 6.67 8 7.5M7 13C8.11 13 9 12.11 9 11C9 9.9 8.11 9 7 9S5 9.9 5 11C5 12.11 5.9 13 7 13M11.5 15C11.5 13.9 10.61 13 9.5 13S7.5 13.9 7.5 15C7.5 16.11 8.4 17 9.5 17S11.5 16.11 11.5 15M12 13C13.11 13 14 12.11 14 11C14 9.9 13.11 9 12 9S10 9.9 10 11C10 12.11 10.9 13 12 13M16.5 15C16.5 13.9 15.61 13 14.5 13S12.5 13.9 12.5 15C12.5 16.11 13.4 17 14.5 17S16.5 16.11 16.5 15M19 11C19 9.9 18.11 9 17 9S15 9.9 15 11C15 12.11 15.9 13 17 13S19 12.11 19 11M17 10.5C16.72 10.5 16.5 10.72 16.5 11S16.72 11.5 17 11.5 17.5 11.28 17.5 11 17.28 10.5 17 10.5M14.5 14.5C14.22 14.5 14 14.72 14 15S14.22 15.5 14.5 15.5 15 15.28 15 15 14.78 14.5 14.5 14.5Z" />
              </svg>
            </a>
            <a class="nav-link" href="#icon-tab-4_{{ i }}" data-bs-toggle="tab" role="tab"
              *ngIf="module.elements[0].name.startsWith('schuko')">
              <svg width="30" height="30" fill="currentColor" viewBox="1 1 22 22">
                <path
                  d="M7.5,10.5A1.5,1.5 0 0,1 9,12A1.5,1.5 0 0,1 7.5,13.5C6.66,13.5 6,12.83 6,12A1.5,1.5 0 0,1 7.5,10.5M16.5,10.5A1.5,1.5 0 0,1 18,12A1.5,1.5 0 0,1 16.5,13.5A1.5,1.5 0 0,1 15,12A1.5,1.5 0 0,1 16.5,10.5M4.22,2H19.78C21,2 22,3 22,4.22V19.78A2.22,2.22 0 0,1 19.78,22H4.22C3,22 2,21 2,19.78V4.22A2.22,2.22 0 0,1 4.22,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
              </svg>
            </a>
          </li>
          <li class="nav-item" *ngIf="module.elements && module.elements[1]">
            <a class="nav-link" href="#icon-tab-5_{{ i }}" data-bs-toggle="tab" role="tab"
              *ngIf="module.elements[1].name.startsWith('mennekes')">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="4 4 16 16"
                class="feather feather-message-square align-middle">
                <path
                  d="M7.5 11C7.5 11.28 7.28 11.5 7 11.5S6.5 11.28 6.5 11 6.72 10.5 7 10.5 7.5 10.72 7.5 11M9.5 14.5C9.22 14.5 9 14.72 9 15S9.22 15.5 9.5 15.5 10 15.28 10 15 9.78 14.5 9.5 14.5M9.5 8C9.78 8 10 7.78 10 7.5S9.78 7 9.5 7 9 7.22 9 7.5 9.22 8 9.5 8M14.5 8C14.78 8 15 7.78 15 7.5S14.78 7 14.5 7 14 7.22 14 7.5 14.22 8 14.5 8M12 10.5C11.72 10.5 11.5 10.72 11.5 11S11.72 11.5 12 11.5 12.5 11.28 12.5 11 12.28 10.5 12 10.5M20 11C20 15.42 16.42 19 12 19S4 15.42 4 11C4 8.61 5.06 6.47 6.72 5H17.28C18.94 6.47 20 8.61 20 11M13 7.5C13 8.33 13.67 9 14.5 9S16 8.33 16 7.5 15.33 6 14.5 6 13 6.67 13 7.5M8 7.5C8 8.33 8.67 9 9.5 9S11 8.33 11 7.5 10.33 6 9.5 6 8 6.67 8 7.5M7 13C8.11 13 9 12.11 9 11C9 9.9 8.11 9 7 9S5 9.9 5 11C5 12.11 5.9 13 7 13M11.5 15C11.5 13.9 10.61 13 9.5 13S7.5 13.9 7.5 15C7.5 16.11 8.4 17 9.5 17S11.5 16.11 11.5 15M12 13C13.11 13 14 12.11 14 11C14 9.9 13.11 9 12 9S10 9.9 10 11C10 12.11 10.9 13 12 13M16.5 15C16.5 13.9 15.61 13 14.5 13S12.5 13.9 12.5 15C12.5 16.11 13.4 17 14.5 17S16.5 16.11 16.5 15M19 11C19 9.9 18.11 9 17 9S15 9.9 15 11C15 12.11 15.9 13 17 13S19 12.11 19 11M17 10.5C16.72 10.5 16.5 10.72 16.5 11S16.72 11.5 17 11.5 17.5 11.28 17.5 11 17.28 10.5 17 10.5M14.5 14.5C14.22 14.5 14 14.72 14 15S14.22 15.5 14.5 15.5 15 15.28 15 15 14.78 14.5 14.5 14.5Z" />
              </svg>
            </a>
            <a class="nav-link" href="#icon-tab-5_{{ i }}" data-bs-toggle="tab" role="tab"
              *ngIf="module.elements[1].name.startsWith('schuko')">
              <svg width="30" height="30" fill="currentColor" viewBox="1 1 22 22">
                <path
                  d="M7.5,10.5A1.5,1.5 0 0,1 9,12A1.5,1.5 0 0,1 7.5,13.5C6.66,13.5 6,12.83 6,12A1.5,1.5 0 0,1 7.5,10.5M16.5,10.5A1.5,1.5 0 0,1 18,12A1.5,1.5 0 0,1 16.5,13.5A1.5,1.5 0 0,1 15,12A1.5,1.5 0 0,1 16.5,10.5M4.22,2H19.78C21,2 22,3 22,4.22V19.78A2.22,2.22 0 0,1 19.78,22H4.22C3,22 2,21 2,19.78V4.22A2.22,2.22 0 0,1 4.22,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
              </svg>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="icon-tab-1_{{ i }}" role="tabpanel">
            <div class="d-flex">
              <span class="badge rounded-pill bg-primary me-3">{{module.version}}</span>
              <h6>{{module.topic_name}}</h6>
            </div>
            {{module.description}}
          </div>
          <div class="tab-pane" id="icon-tab-2_{{ i }}" role="tabpanel">
            <div class="d-flex justify-content-between">
              <h4 class="tab-title">Config</h4>
              <button type="submit" class="btn btn-primary" (click)="getData(module.topic_name, 'cfg')">Get
                local</button>
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error.cfg==module.topic_name">
              <div class="alert-message">
                {{ "notResponse" | translate }}
              </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert"
              *ngIf="successMessage.cfg==module.topic_name">
              <div class="alert-message">
                {{"updatedSuccesfully" | translate}}
              </div>
            </div>
            <table class="table white">
              <thead>
                <tr>
                  <th>{{"key" | translate}}</th>
                  <th>{{"value" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of module.cfg | keyvalue">
                  <td>{{item.key}}</td>
                  <td>{{item.value | stringify}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="icon-tab-3_{{ i }}" role="tabpanel">
            <div class="d-flex justify-content-between">
              <h4 class="tab-title">State</h4>
              <button type="submit" class="btn btn-primary" (click)="getData(module.topic_name, 'stat')">Get
                local</button>
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error.stat==module.topic_name">
              <div class="alert-message">
                {{ "notResponse" | translate }}
              </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert"
              *ngIf="successMessage.stat==module.topic_name">
              <div class="alert-message">
                {{"updatedSuccesfully" | translate}}
              </div>
            </div>
            <table class="table white">
              <thead>
                <tr>
                  <th>{{"key" | translate}}</th>
                  <th>{{"value" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of module.stat | keyvalue">
                  <td>{{item.key}}</td>
                  <td>{{item.value | stringify}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="icon-tab-analyzer_{{ i }}" role="tabpanel">
            <div class="d-flex justify-content-between">
              <h4 class="tab-title">Analyzers</h4>
              <button type="submit" class="btn btn-primary" (click)="getDataAnalyzers()">Get </button>
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorElement==='Analyzer'">
              <div class="alert-message">
                {{ "notResponse" | translate }}
              </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessageElement==='Analyzer'">
              <div class="alert-message">
                {{"updatedSuccesfully" | translate}}
              </div>
            </div>
            <table class="table white">
              <thead>
                <tr>
                  <th>{{"serial" | translate}}</th>
                  <th>{{"energyValues" | translate}}</th>
                  <th>{{"measureValues" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of formattedData ">
                  <td>{{item.serial }}</td>
                  <td> {{item.stat.energyValues | jsonStringify }} </td>
                  <td> {{item.stat.measureValues | jsonStringify }} </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="tab-pane" id="icon-tab-clock{{ i }}" role="tabpanel">
            <div class="d-flex justify-content-between">
              <h4 class="tab-title">Clock</h4>
              <button type="submit" class="btn btn-primary" (click)="getAstCalendar()">Get </button>
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorElement==='Analyzer'">
              <div class="alert-message">
                {{ "notResponse" | translate }}
              </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessageElement==='Analyzer'">
              <div class="alert-message">
                {{"updatedSuccesfully" | translate}}
              </div>
            </div>
            <table class="table" style="background-color: white; margin-bottom: 0px;">
              <thead>
                <tr>
                  <th>geoloc</th>
                  <th>{{"values" | translate}}</th>
                </tr>
              </thead>
              <tbody *ngIf="clock != null">
                <tr>
                  <td>timezone</td>
                  <td>{{clock.timezone }}</td>
                </tr>
                <tr>
                  <td>timezoneCode</td>
                  <td>{{clock.timezoneCode }}</td>
                </tr>
                <tr>
                  <td>coords</td>
                  <td>{{clock.coords }}</td>
                </tr>
                <tr>
                  <td>astCorr</td>
                  <td> {{clock.astCorr[0] }}</td>
                </tr>
                <tr>

              </tbody>
            </table>
          </div>

          <div class="tab-pane" id="icon-tab-4_{{ i }}" role="tabpanel" *ngIf="module.elements && module.elements[0]">
            <div class="d-flex justify-content-between">
              <h4 class="tab-title">{{module.elements[0].name}}</h4>
              <button type="submit" class="btn btn-primary" (click)="getElementData(module.topic_name, i, 0)">Get
                local</button>
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorElement==module.topic_name">
              <div class="alert-message">
                {{ "notResponse" | translate }}
              </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert"
              *ngIf="successMessageElement==module.topic_name">
              <div class="alert-message">
                {{"updatedSuccesfully" | translate}}
              </div>
            </div>
            <div class="tab tab-primary">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" *ngIf="module.elements[0].data && module.elements[0].data.cfg">
                  <a class="nav-link" [ngClass]="{'active': module.elements[0].data.cfg}" href="#element_tab_{{i}}_1_1"
                    data-bs-toggle="tab" role="tab">Config</a>
                </li>
                <li class="nav-item" *ngIf="module.elements[0].data && module.elements[0].data.stat">
                  <a class="nav-link" [ngClass]="{'active': !module.elements[0].data.cfg}" href="#element_tab_{{i}}_1_2"
                    data-bs-toggle="tab" role="tab">State</a>
                </li>
              </ul>
              <div class="tab-content" style="padding:5px">
                <div class="tab-pane" [ngClass]="{'active show': module.elements[0].data.cfg}"
                  id="element_tab_{{i}}_1_1" role="tabpanel">
                  <table class="table" style="background-color: white; margin-bottom: 0px;">
                    <thead>
                      <tr>
                        <th>{{"key" | translate}}</th>
                        <th>{{"value" | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of module.elements[0].data.cfg | keyvalue">
                        <td>{{item.key}}</td>
                        <td>{{item.value | stringify}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane" [ngClass]="{'show active': !module.elements[0].data.cfg}"
                  id="element_tab_{{i}}_1_2" role="tabpanel">
                  <table class="table" style="background-color: white; margin-bottom: 0px;">
                    <thead>
                      <tr>
                        <th>{{"key" | translate}}</th>
                        <th>{{"value" | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of module.elements[0].data.stat | keyvalue">
                        <td>{{item.key}}</td>
                        <td>{{item.value | stringify}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="icon-tab-5_{{ i }}" role="tabpanel" *ngIf="module.elements && module.elements[1]">
            <div class="d-flex justify-content-between">
              <h4 class="tab-title">{{module.elements[1].name}}</h4>
              <button type="submit" class="btn btn-primary" (click)="getElementData(module.topic_name, i, 1)">Get
                local</button>
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorElement==module.topic_name">
              <div class="alert-message">
                {{ "notResponse" | translate }}
              </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert"
              *ngIf="successMessageElement==module.topic_name">
              <div class="alert-message">
                {{"updatedSuccesfully" | translate}}
              </div>
            </div>
            <div class="tab tab-primary">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" *ngIf="module.elements[1].data && module.elements[1].data.cfg">
                  <a class="nav-link" [ngClass]="{'active': module.elements[1].data.cfg}" href="#element_tab_{{i}}_2_1"
                    data-bs-toggle="tab" role="tab">{{"configuraton" | translate}}</a>
                </li>
                <li class="nav-item" *ngIf="module.elements[1].data && module.elements[1].data.stat">
                  <a class="nav-link" [ngClass]="{'active': !module.elements[1].data.cfg}" href="#element_tab_{{i}}_2_2"
                    data-bs-toggle="tab" role="tab">{{"state" | translate}}</a>
                </li>
              </ul>
              <div class="tab-content" style="padding:5px">
                <div class="tab-pane" [ngClass]="{'active show': module.elements[1].data.cfg}"
                  id="element_tab_{{i}}_2_1" role="tabpanel">
                  <table class="table" style="background-color: white; margin-bottom: 0px;">
                    <thead>
                      <tr>
                        <th>{{"key" | translate}}</th>
                        <th>{{"value" | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of module.elements[1].data.cfg | keyvalue">
                        <td>{{item.key}}</td>
                        <td>{{item.value | stringify}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane" [ngClass]="{'active show': !module.elements[1].data.cfg}"
                  id="element_tab_{{i}}_2_2" role="tabpanel">
                  <table class="table" style="background-color: white; margin-bottom: 0px;">
                    <thead>
                      <tr>
                        <th>{{"key" | translate}}</th>
                        <th>{{"value" | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of module.elements[1].data.stat | keyvalue">
                        <td>{{item.key}}</td>
                        <td>{{item.value | stringify}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="tab-pane" id="icon-tab-4_{{i}}_0" role="tabpanel" *ngIf="module.elements?.lenght>0">
                        <h4 class="tab-title">{{module.elements[0].name}}</h4>
                        <table class="table white">
                            <thead>
                                <tr>
                                    <th>Key</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane" id="icon-tab-4_{{i}}_1" role="tabpanel" *ngIf="module.elements?.lenght>1">
                        <h4 class="tab-title">{{module.elements[1].name}}</h4>
                        <table class="table white">
                            <thead>
                                <tr>
                                    <th>Key</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>-->
        </div>
      </div>
    </div>
  </div>
</div>


    <!-- Modal -->
<div class="modal fade" id="importConfigModal" tabindex="-1" aria-labelledby="importConfigModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl import-config-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="importConfigModalLabel">Import Configuration</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div *ngIf="importSuccessMessage === '' ">


          <!-- File Input Section -->
          <div class="mb-4">
            <label for="importFile" class="form-label fw-600">Selecciona archivo JSON:</label>
            <input type="file" id="importFile" name="importFile" class="form-control" accept="application/json,.json" (change)="importModules()">
          </div>
        </div>

          <!-- Alert Messages -->
          <div class="alert alert-danger alert-dismissible fade show import-modal-alert" role="alert" *ngIf="importErrorMessage">
            <i class="fas fa-exclamation-circle me-2 fs-5"></i>
            <strong>Error:</strong> <span class="import-modal-alert-text">{{ importErrorMessage }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>

          <div class="alert alert-success alert-dismissible fade show import-modal-alert text-dark" role="alert" *ngIf="importSuccessMessage">
            <i class="fas fa-check-circle me-2 fs-5"></i>
            <strong>Éxito:</strong> <span class="import-modal-alert-text">{{ importSuccessMessage }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>


        <!-- Modules List Section -->
        <div class="mt-4" *ngIf="importedModules.length">
          <hr>
          <h6 class="mb-3"><i class="fas fa-list me-2 text-primary"></i>Módulos detectados</h6>
          <div class="d-flex flex-nowrap gap-2 pb-2 import-modules-row">
            <div
              *ngFor="let module of importedModules"
              class="border rounded-3 bg-white px-3 py-2 flex-shrink-0 import-module-card"
              [class.border-primary]="selectedImportedModule?.topic_name === module.topic_name"
              [class.bg-primary-subtle]="selectedImportedModule?.topic_name === module.topic_name"
              (click)="selectImportedModule(module)">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <div class="form-check mb-0">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="module.selected"
                    (click)="$event.stopPropagation()"
                    (change)="toggleImportedModuleSelection(module, $event)">
                </div>
              </div>
              <div class="fw-600 text-truncate" style="max-width: 180px;">{{ module.name }}</div>
              <small class="text-muted d-block text-truncate" style="max-width: 180px;">{{ module.topic_name }}</small>
              <small class="d-block mt-1 text-secondary">
                <i class="fas fa-cog me-1"></i>{{ getConfigSize(module.cfg) }}
              </small>
            </div>
          </div>

          <!-- Module Details -->
          <div class="mt-4" *ngIf="selectedImportedModule as module">
            <hr>
            <h6 class="mb-3"><i class="fas fa-code me-2 text-primary"></i>Configuración</h6>
            <div class="card border-0 bg-light shadow-sm">
              <div class="card-header bg-white border-bottom">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <strong class="d-block">{{ module.name }}</strong>
                    <small class="text-muted">{{ module.topic_name }}</small>
                  </div>
                  <div class="text-end">
                    <small class="d-block"><i class="fas fa-cog me-1 text-info"></i><strong>{{ getConfigSize(module.cfg) }}</strong></small>
                    <small class="d-block text-muted"><i class="fas fa-layer-group me-1"></i>{{ module.elements?.length || 0 }} elementos</small>
                  </div>
                </div>
              </div>
              <div class="card-body p-3 overflow-auto" style="max-height: 300px;">
                <pre class="mb-0 small text-break bg-light bg-opacity-25">{{ module | jsonStringify }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer import-modal-footer flex-column align-items-stretch gap-0">
        <div class="import-footer-results w-100" *ngIf="importSummaryMessage || importResults.length">
          <div
            class="alert alert-dismissible fade show import-modal-alert import-summary-alert mb-2"
            role="alert"
            *ngIf="importSummaryMessage"
            [class.alert-success]="importSummaryType === 'success'"
            [class.alert-warning]="importSummaryType === 'warning'"
            [class.alert-danger]="importSummaryType === 'danger'"
            [class.text-dark]="importSummaryType === 'warning'">
            <i
              class="fas me-2 fs-5"
              [class.fa-check-circle]="importSummaryType === 'success'"
              [class.fa-exclamation-triangle]="importSummaryType === 'warning'"
              [class.fa-times-circle]="importSummaryType === 'danger'"></i>
            <strong>Resumen:</strong> <span class="import-modal-alert-text">{{ importSummaryMessage }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>

          <div class="import-results" *ngIf="importResults.length">
            <h6 class="mb-2"><i class="fas fa-clipboard-check me-2 text-primary"></i>Detalle por módulo</h6>
            <div class="import-results-list">
              <div
                *ngFor="let result of importResults"
                class="import-result-item"
                [class.import-result-item-success]="result.success"
                [class.import-result-item-error]="!result.success">
                <i
                  class="fas mt-1"
                  [class.fa-check-circle]="result.success"
                  [class.text-success]="result.success"
                  [class.fa-times-circle]="!result.success"
                  [class.text-danger]="!result.success"></i>
                <div class="import-result-content">
                  <strong class="text-uppercase">{{ result.module }}</strong>
                  <small class="d-block import-modal-alert-text">{{ result.message }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 w-100 import-modal-footer-actions">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="close()">Cerrar</button>
          <button type="button" class="btn btn-primary" [disabled]="!importedModules.length || !hasSelectedModules()" (click)="applyImportedModules()">Enviar configuración</button>
        </div>
      </div>
    </div>
  </div>
</div>
